import { $TSFixMe } from 'types/ts-migrate'

export const isNil = (children: any): $TSFixMe =>
  children === null || children === undefined || (Array.isArray(children) && children.length === 0)
